export default{ // Used for the News’ Homepage，adjust the order of newsItems to match the order of the news on the website
    data() {
        return {
        en:{
            news_title: 'News Center',
            topNews: [
              {
                id: 1,
                image: require('@/assets/img/News/NewsHomePage/008-VRParkPageWallpaper.png'),
                title: 'Top News: Rosy Nebula established cooperative relationship with VR Vidámpark team',
                description: 'Rosy Nebula works with a Hungarian team to launch a VR theme park project',
                DetailPageName: "008-VRParkPage"
              },
            ],
          newsItems: [
            {
              id: 1,
              image: require('@/assets/img/News/NewsHomePage/001-Logo_news_edited.jpg'), 
              title: ' Rosy Nebula officially settled in UNNC International Innovation and Entrepreneurship Industrial Park',
              description: 'Rosy Nebula entered UNNC to deepen industry-university-research cooperation.',
              DetailPageName: "001-CompanyEstablishedPage"
            },
            {
              id: 2,
              image: require('@/assets/img/News/NewsHomePage/002-CeramsiteFactoryPageWallpaper_news_edited.png'),
              title: 'Rosy Nebula starts a new chapter: CG animation shows the production process of ceramsite factory',
              description: 'In August 2022, Rosy Nebulas first project, a  CG animation shows production process of ceramsite was complete ',
              DetailPageName: "002-CeramsiteFactoryPage"
            },
            {
              id: 3,
              image: require('@/assets/img/News/NewsHomePage/003-XiangShanPageWallpaper_news_edited.jpg'),
              title: 'Rosy Nebula and Xiangshan Global Studios reached a strategic cooperation to jointly promote the development of digital cultural tourism',
              description: 'Rosy Nebula reached cooperation with Xiangshan Global studios and will provide technical support for it',
              DetailPageName: "003-XiangShanPage"
            },
            {
              id: 4,
              image: require('@/assets/img/News/NewsHomePage/004-LightShowPageWallpaper_news_edited.png'),
              title: 'Xiangshan Global Studios Wonderful Night of the Tang and Song Dynasties cultural night tour activity opened hot, Rosy Nebula technical support to help innovative experience',
              description: 'Rosy Nebula provided supporting technical services for the Wonderful Night of the Tang and Song Dynasties',
              DetailPageName: "004-LightShowPage"
            },
            {
              id: 5,
              image: require('@/assets/img/News/NewsHomePage/005-IEBPageWallpaper_news_edited.png'),
              title: ' Rosy Nebula officially settled in UNNC International Innovation and Entrepreneurship Industrial Park',
              description: 'Rosy Nebula entered UNNC to deepen industry-university-research cooperation.',
              DetailPageName: "005-IEBPage"
            },
            {
              id: 6,
              image: require('@/assets/img/News/NewsHomePage/006-cover.png'),
              title: 'Rosy Nebula and Consultant Ningning Xu started the Joint Project - VR Music Game',
              description: 'Promote the wide application of VR technology in the field of music',
              DetailPageName: "006-VRMusicPage"
            },
            {
              id: 7,
              image: require('@/assets/img/News/NewsHomePage/007-InnovationEntrepreneurshipPageWallpaper_news_edited.png'),
              title: 'Central and Eastern Europe Youth Innovation and Entrepreneurship Competition was successfully held in Ningbo -- Rosy Nebula shared the entrepreneurial achievements',
              description: 'Rosy Nebula shared their entrepreneurial experience at the Innovation and Entrepreneurship Exchange Seminar',
              DetailPageName: "007-InnovationEntrepreneurshipPage"
            },
            {
              id: 8,
              image: require('@/assets/img/News/NewsHomePage/008-VRParkPageWallpaper.png'),
              title: 'Rosy Nebula established cooperative relationship with VR Vidámpark team to expand China s VR theme park market',
              description: 'Rosy Nebula works with a Hungarian team to launch a VR theme park project',
              DetailPageName: "008-VRParkPage"
            },
            {
              id: 9,
              image: require('@/assets/img/News/NewsHomePage/009-cover.jpg'),
              title: 'Rosy Nebula attended the Global Pitch',
              description: 'Further upgrade cooperation with the VR Vidámpark team -- deepen international exchanges and cooperation.',
              DetailPageName: "009-GlobalPitch2024"
            },
            {
              id: 10,
              image: require('@/assets/img/News/NewsHomePage/010-cover.jpeg'),
              title: 'The first VR LBE Centre in Ningbo Central city ‘Fairytale’ hot opening!',
              description: 'Rosy Nebula, in collaboration with VR Vidámpark and Ningbo Science Discovery Centre, has created a brand new masterpiece!',
              DetailPageName: "010-VRParkFairyTale"
            },
            {
              id: 11,
              image: require('@/assets/img/News/NewsHomePage/011-cover.jpg'),
              title: 'Golden autumn, orcabeat VR park officially opened!',
              description: 'Together with VR Vidámpark and Ningbo Fangte, a different VR experience!',
              DetailPageName: "011-VRParkOrcaBeat"
            },
            {
              id: 12,
              image: require('@/assets/img/News/NewsHomePage/012-cover.jpg'),
              title: `Rosy Nebula's Large-Space VR Project was exhibited at the ‘Haisi Cultural Tourism Exhibition’`,
              description: `VR content created by Rosy Nebula's technical team makes its premiere`,
              DetailPageName: "012-CulturalExhibition"
            },
          ],
        }
      }
    }
    };